import apiClient from '../lib/apiClient';

import {
  DOWNLOAD_INVOICE_API_ENDPOINT,
  DOWNLOAD_RECEIPT_API_ENDPOINT,
} from '../constants/apiEndpoints';

export interface IDownloadInvoiceVariables {
  invoice_id: string;
}

export type TPostDownloadInvoiceResponseData = Blob;

export const postDownloadInvoice = async (
  variables: IDownloadInvoiceVariables
) => {
  const { invoice_id } = variables;

  const response = await apiClient.post<TPostDownloadInvoiceResponseData>(
    DOWNLOAD_INVOICE_API_ENDPOINT,
    {
      invoice: {
        invoice_id,
      },
    },
    {
      responseType: 'blob',
    }
  );

  return response.data;
};

export type TPostDownloadReceiptResponseData = Blob;

export interface IDownloadReceiptVariables {
  payment_id: number;
}

export const postDownloadReceipt = async (
  variables: IDownloadReceiptVariables
) => {
  const { payment_id } = variables;

  const response = await apiClient.post<TPostDownloadReceiptResponseData>(
    DOWNLOAD_RECEIPT_API_ENDPOINT,
    {
      receipt: {
        payment_id,
      },
    },
    {
      responseType: 'blob',
    }
  );

  return response.data;
};
